<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" epub:type="z3998:published-works" id="also-by">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">PRAISE FOR RUBY SOAMES</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left also-by-content"><b>The ChickLit Club, September 2011</b></p>
<p class="alignment-block-content alignment-block-content-left also-by-content">Ruby Soames writes with an eloquence and lyricism that belies the fact that this is her first novel, and absolutely nails the characterisation.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left also-by-content"><b>France Magazine</b></p>
<p class="alignment-block-content alignment-block-content-left also-by-content">This debut novel by Ruby Soames is fast-paced and finely crafted, examining in great detail the impact of grief and the minutiae of love. And it's a real page-turner; as the story progresses, the reader can't help but be drawn into the plot - it really is an irresistible read.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left also-by-content"><b>The Riviera Reporter: Bookshelf</b></p>
<p class="alignment-block-content alignment-block-content-left also-by-content">Soames offers a McEwanish sophistication of style and structure.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left also-by-content"><b>Jerwood Uncovered Fiction Prize 2013 - Sara Veale</b></p>
<p class="alignment-block-content alignment-block-content-left also-by-content">Ruby Soames manages to marry tender subject matter with a remarkably compelling plot in <i>Seven Days to Tell You</i>. Its restrictive time frame ensures it remains gripping throughout – revelations are divulged reliably up until the last page, and we are permitted little respite from Kate’s quandary: “I need to pull the plug one way or another. You stay or you go, either way, I can start living.” Our reprieve is ultimately reserved for the last page, when the truth accompanying Marc’s desertion is uncovered and Kate discloses her long-awaited decision.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left also-by-content"><b>Claire McAlpine Word by Word</b></p>
<p class="alignment-block-content alignment-block-content-left also-by-content">This book has a way of hooking you in and stirring your curiosity in an unputdownable kind of way. It shifts and changes in time and point of view, keeping you wondering and guessing through its many twists and turns.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise-for-ruby-soames.vue?27a29e96